import { FC, useState, useEffect } from 'react';

export interface IBankAccountLast4DigitsOptions {
    id: string;
    value?: number | string;
    onChange(loanNumber: string): void;
    isReadOnly?: boolean;
}

export const BankAccountLast4Digits: FC<IBankAccountLast4DigitsOptions> = ({
    id = 'bankAccountLast4Digits',
    value = '',
    onChange,
    isReadOnly = false,
}) => {
    const rgxString = '^[0-9]{4}$';

    const [isNumberValid, set_isNumberValid] = useState(true);

    useEffect(() => {
        if (!value) {
            set_isNumberValid(true);
            return;
        }
        const isOk = validateNumber(value);
        set_isNumberValid(isOk);
    }, [value]);

    const validateNumber = (input) => {
        if (!input) {
            return true;
        }
        const rgx = new RegExp(rgxString, 'g');
        const isOk = rgx.test(input);
        return isOk;
    };

    const setBankAccountNumber = (input) => {
        let cleanedInput = input.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');
        if (!cleanedInput || isNaN(cleanedInput)) {
            cleanedInput = '';
        } else {
            cleanedInput = cleanedInput.toString();
        }

        onChange(cleanedInput);
    };

    return (
        <input
            className={!isNumberValid ? 'not-valid' : undefined}
            type='text'
            value={value ?? ''}
            id={id}
            onChange={(event) => setBankAccountNumber(event.target.value)}
            maxLength={4}
            disabled={isReadOnly}
        />
    );
};
